import { SyntheticEvent, useCallback, useEffect, useState } from 'react';

import debounce from 'lodash/debounce';
import store from 'store';

import useModel from '@common/helpers/useModel';
import BooksModel, { IBooksModel } from '@common/models/Books/Books';

import BooksTabs from '../constants/Tabs';

export default function useBooks() {
	const [tab, setTab] = useState(0);

	const { currentStudentId } = store;
	const { id: currentServiceId } = store.services.current;

	const books = useModel(
		BooksModel,
		{
			limit: 99,
			service_id: currentServiceId,
			studentId: currentStudentId,
			isEnabled: true,
		},
		[currentServiceId, currentStudentId],
		{ disableFetch: true },
	) as IBooksModel;

	useEffect(() => {
		if (currentServiceId) {
			books.fetch();
			books.fetchBooksProgress(currentStudentId);
		}
	}, [currentStudentId]);

	const handleChangeTab = (_: SyntheticEvent, newValue: number) => {
		setTab(newValue);
		books.setBookTypeId(BooksTabs[newValue].book_type_id);
	};

	const debouncedFetch = useCallback(
		debounce((term: string) => {
			books.setSearch(term);
			books.fetch();
		}, 500),
		[currentServiceId],
	);

	const handleSearch = (term: string) => {
		debouncedFetch(term);
	};

	return {
		tab,
		handleChangeTab,
		books,
		handleSearch,
	};
}
